export default __webpack_public_path__ + "assets/models/a61430c4a668ca2c901babab88006ec2.glb";